import { discountCodes } from '@markku/db'
import { createInsertSchema, createSelectSchema } from 'drizzle-zod'
import { z } from 'zod'

// Response schema — omit internal audit fields; clients don't need DB metadata.
export const selectDiscountCodeSchema = createSelectSchema(discountCodes).omit({
  createdAt: true,
  updatedAt: true,
  deletedAt: true,
})

export const insertDiscountCodeSchema = createInsertSchema(discountCodes).omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  deletedAt: true,
})

// A discount code enriched with usage stats for the admin list view.
// visitCount = non-cancelled visits that used the code; revenue = gross service
// revenue of those visits; totalDiscount = total discount given (gross).
export const discountCodeWithStatsSchema = selectDiscountCodeSchema.extend({
  visitCount: z.number(),
  revenue: z.number(),
  totalDiscount: z.number(),
  // Minted by the huoltosuositus automation for one customer, as opposed to
  // a campaign code typed in by an admin.
  personal: z.boolean(),
})

export type DiscountCode = z.infer<typeof selectDiscountCodeSchema>
export type CreateDiscountCode = z.infer<typeof insertDiscountCodeSchema>
export type DiscountCodeWithStats = z.infer<typeof discountCodeWithStatsSchema>
